export default __webpack_public_path__ + "static/media/Close.b3800062.svg";